// extracted by mini-css-extract-plugin
export var logo = "_l2-2";
export var logoWrapper = "_l2-1";
export var strip = "_l2-0";